import { z } from 'zod';
/** The job a `SYNC_LIST` feed runs, which also decides what a row in it means. */
export var FeedListJobKind;
(function (FeedListJobKind) {
    FeedListJobKind["AppointmentUpdateAggregation"] = "APPOINTMENT_UPDATE_AGGREGATION";
    FeedListJobKind["CalendarSync"] = "CALENDAR_SYNC";
    FeedListJobKind["Outreach"] = "OUTREACH";
    FeedListJobKind["PatientList"] = "PATIENT_LIST";
    FeedListJobKind["PatientOrders"] = "PATIENT_ORDERS";
})(FeedListJobKind || (FeedListJobKind = {}));
export const FeedListJobKindSchema = z.enum(FeedListJobKind);
/** The subset of list jobs that expose data bindings, and so can be mapped field by field. */
export const FEED_SYNC_JOBS = [
    FeedListJobKind.CalendarSync,
    FeedListJobKind.Outreach,
    FeedListJobKind.PatientOrders,
];
export const FeedSyncJobSchema = z.enum(FEED_SYNC_JOBS);
export var FeedCalendarSyncReportType;
(function (FeedCalendarSyncReportType) {
    FeedCalendarSyncReportType["Confirmation"] = "CONFIRMATION";
    FeedCalendarSyncReportType["MammoScheduling"] = "MAMMO_SCHEDULING";
    FeedCalendarSyncReportType["PriorBalance"] = "PRIOR_BALANCE";
    FeedCalendarSyncReportType["Scheduling"] = "SCHEDULING";
})(FeedCalendarSyncReportType || (FeedCalendarSyncReportType = {}));
export const FeedCalendarSyncReportTypeSchema = z.enum(FeedCalendarSyncReportType);
//# sourceMappingURL=listJob.js.map